import React from "react";
import { Folder, FolderTree, Plus } from "lucide-react";
import crossIcon from "../../assets/UserIcons/Cancel.svg";

export default function UploadFolderModal({
  show,
  folders,
  selectedFolderId,
  onSelectFolder,
  onClose,
  onConfirm,
  loading = false,
  embedded = false,
  onCreateFolder,
  canCreateFolder = false,
}) {
  if (!show) return null;

  const selectedId =
    selectedFolderId && typeof selectedFolderId === "object"
      ? selectedFolderId.id
      : selectedFolderId;
  const getFolderId = (folder) =>
    folder?.id ?? folder?.folder_id ?? folder?.user_files_id;
  const getParentId = (folder) => {
    const parentId = folder?.parentId ?? folder?.parent_id ?? null;
    return parentId === null || parentId === undefined
      ? null
      : String(parentId);
  };
  const isSelected = (folderId) =>
    selectedId === null
      ? folderId === null
      : String(selectedId) === String(folderId);

  const renderFolders = (parentId = null, depth = 0) => {
    return folders
      .filter(
        (folder) =>
          folder.itemType === "folder" &&
          getParentId(folder) === (parentId === null ? null : String(parentId)),
      )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((folder) => {
        const folderId = getFolderId(folder);

        return (
          <React.Fragment key={folderId}>
            <div
              className={`repo-folder-option ${
                isSelected(folderId) ? "selected" : ""
              }`}
              style={{
                paddingLeft: `${depth * 20 + 16}px`,
              }}
              onClick={() => onSelectFolder(folderId)}
            >
              <Folder size={16} className="me-2" />
              {folder.name}
            </div>

            {renderFolders(folderId, depth + 1)}
          </React.Fragment>
        );
      });
  };

  const content = (
    <div
      className={`document-modal modal-content text-center ${
        embedded ? "upload-folder-modal-embedded" : ""
      }`}
      style={
        embedded
          ? undefined
          : {
              maxWidth: "500px",
              width: "90%",
            }
      }
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header justify-content-center position-relative p-0">
        <button
          className="modal-close-btn position-absolute"
          onClick={onClose}
          aria-label="Close"
        >
          <img src={crossIcon} className="icon-image" alt="Close" />
        </button>
      </div>

      <div className="modal-body">
        {!embedded && (
          <div className="d-flex justify-content-center align-items-center mb-3">
            <div className="modal-icon-wrapper rounded-circle d-flex justify-content-center align-items-center p-3">
              <FolderTree size={36} className="text-black" />
            </div>
          </div>
        )}

        <h5 className="fw-semibold mb-2">Select Destination Folder</h5>

        <p className="mb-3">
          Choose the folder where the uploaded files should be stored.
        </p>

        <div className="repo-folder-tree custom-ak-scollbar">
          <div
            className={`repo-folder-option ${
              isSelected(null) ? "selected" : ""
            }`}
            onClick={() => onSelectFolder(null)}
          >
            <Folder size={16} className="me-2" />
            Root Directory
          </div>

          {renderFolders()}
        </div>

        {onCreateFolder && (
          <div className="upload-folder-create-row">
            <button
              type="button"
              className="custom-btn d-inline-flex align-items-center justify-content-center gap-1"
              onClick={onCreateFolder}
              disabled={!canCreateFolder}
              aria-disabled={!canCreateFolder}
              title={
                canCreateFolder
                  ? "Create Folder"
                  : "Create Folder is unavailable for Global uploads"
              }
            >
              <Plus size={16} />
              Create Folder
            </button>
          </div>
        )}
      </div>

      <div className="modal-footer justify-content-center gap-3">
        <button
          className="cancle-btn w-25 border border-1 fw-semibold"
          onClick={onClose}
        >
          Cancel
        </button>

        <button
          className="custom-btn w-25"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );

  if (embedded) return content;

  return (
    <div className="modal modal-backdrop-custom d-block" onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered">{content}</div>
    </div>
  );
}
